/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { GET_FORMDATA_ORDINANCE_REVISION_RPT } from 'modules/real-property-tax/components/constant';

import GeneralRevisionContainer from './general-revisions/container/GeneralRevisionContainer';
import TransactionCodesContainer from './transaction-codes/container/TransactionCodesContainer';
import PenaltyContainer from './penalties/container/PenaltyContainer';
import OrdinanceRevisionContainer from './ordinance-revisions/container/OrdinanceRevisionContainer';
import CodedValueContainer from './coded-value/container/CodedValueContainer';
import PropertyLocationsRoutes from './property-locations/PropertyLocationsRoutes';
import OrdinanceRevisionDropdown from '../components/OrdinanceRevisionDropdown';

function SettingsRoutes({ match, pathName }) {
  const permissions = getJson('permissions');
  const dropDownFormData = useSelector(
    ({ api }) => _.get(api, `${GET_FORMDATA_ORDINANCE_REVISION_RPT}.item`) || {}
  );

  const ordinanceRevisionId =
    parseInt(_.get(dropDownFormData, 'year.value'), 10) ||
    JSON.parse(localStorage.getItem('defaultFormValue'))?.year?.value;

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              {Acl(permissions, ['E2E RPT SETTINGS TRANSACTION CODES']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/settings/transaction-codes"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf('rpt/settings/transaction-codes') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Transaction Codes
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT SETTINGS PENALTIES']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/settings/penalties"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf('rpt/settings/penalties') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Penalties
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT SETTINGS ORDINANCE REVISIONS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/settings/ordinance-revisions"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf('rpt/settings/ordinance-revisions') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Ordinance Revisions
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT SETTINGS CODED VALUES']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/settings/coded-value"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf('rpt/settings/coded-value') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Coded Values
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT SETTINGS PROPERTY LOCATIONS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/settings/property-locations"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf('rpt/settings/property-locations') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Property Locations
                  </Link>
                </li>
              )}
              {Acl(permissions, ['E2E RPT SETTINGS VIEW GENERAL REVISIONS']) && (
                <li className="nav-item">
                  <Link
                    to="/rpt/settings/general-revisions"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 mt-2 ${
                      pathName.indexOf('rpt/settings/general-revisions') > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    General Revisions
                  </Link>
                </li>
              )}
            </ul>
            {
              <div className="d-flex ml-auto mt-3">
                <div
                  className="d-flex justify-content-end align-items-center mr-5"
                  style={{ flexGrow: '2' }}
                >
                  <OrdinanceRevisionDropdown pathName={pathName} />
                </div>
              </div>
            }
          </div>
        </div>
        <Switch>
          {Acl(permissions, ['E2E RPT SETTINGS TRANSACTION CODES']) && (
            <Route
              exact
              path={`${match.path}`}
              render={() => <Redirect to={`${match.path}/transaction-codes`} />}
            />
          )}
          {Acl(permissions, ['E2E RPT SETTINGS TRANSACTION CODES']) && (
            <Route
              path={`${match.path}/transaction-codes`}
              component={TransactionCodesContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT SETTINGS PENALTIES']) && (
            <Route
              path={`${match.path}/penalties`}
              render={() => (
                <PenaltyContainer ordinanceRevisionId={ordinanceRevisionId} />
              )}
            />
          )}
          {Acl(permissions, ['E2E RPT SETTINGS ORDINANCE REVISIONS']) && (
            <Route
              path={`${match.path}/ordinance-revisions`}
              component={OrdinanceRevisionContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT SETTINGS CODED VALUES']) && (
            <Route
              path={`${match.path}/coded-value`}
              component={CodedValueContainer}
            />
          )}
          {Acl(permissions, ['E2E RPT SETTINGS PROPERTY LOCATIONS']) && (
            <Route
              path={`${match.path}/property-locations`}
              component={PropertyLocationsRoutes}
            />
          )}
          {Acl(permissions, ['E2E RPT SETTINGS VIEW GENERAL REVISIONS']) && (
            <Route
              path={`${match.path}/general-revisions`}
              component={GeneralRevisionContainer}
            />
          )}
        </Switch>
      </div>
    </React.Fragment>
  );
}

SettingsRoutes.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(SettingsRoutes);
